// OLD SO utilities

import {
  type PictureUpdateInput,
  type PicturePartsFragment,
  LifecycleStatus,
} from '~/apollo/generated/v4/graphql';

export type SupportObjectParentType = 'outcrop' | 'study';

/** Client-side type for differentiating SO types */
export type SupportObjectType =
  | 'crossSection'
  | 'sedimentaryLog'
  | 'facies'
  | 'wellLog'
  | 'production'
  | 'reservoirModel'
  | 'trainingImage'
  | 'variogram'
  | 'gigaPan';

export interface PictureFormValues {
  name: string;
  description: string;
  type: string;
  author: string;
  scale: string;
  comments: string;
  outcropTagId: string | number;
  priority: string | number;
  published: boolean;
}

type PictureUpdateParts = Pick<
  PicturePartsFragment,
  | 'name'
  | 'description'
  | 'type'
  | 'author'
  | 'scale'
  | 'comments'
  | 'outcropTagId'
  | 'priority'
  | 'lifecycleStatus'
>;

export function initialPicture(picture?: PictureUpdateParts) {
  return {
    name: picture?.name ?? '',
    description: picture?.description ?? '',
    type: picture?.type ?? '',
    author: picture?.author ?? '',
    scale: picture?.scale ?? '',
    comments: picture?.comments ?? '',
    outcropTagId: picture?.outcropTagId ?? '',
    priority: picture?.priority ?? '',
    published: picture?.lifecycleStatus === LifecycleStatus.Published,
  };
}

const castToNullableNumber = (value: string | number) => {
  if (typeof value === 'number') return value;
  else if (!value.length) return null;

  const result = parseInt(value);
  if (Number.isNaN(result)) return null;
  return result;
};

export function formValuesToPictureInput(
  values: PictureFormValues,
): PictureUpdateInput {
  const { published, ...otherValues } = values;
  return {
    ...otherValues,
    priority: castToNullableNumber(values.priority),
    outcropTagId: castToNullableNumber(values.outcropTagId),
    lifecycleStatus: values.published
      ? LifecycleStatus.Published
      : LifecycleStatus.Draft,
  };
}
